"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionActionMap = exports.TransactionAction = exports.TransactionStatusEnum = void 0;
// TODO find a way to keep one copy of this.
// It is currently reproduced as a Prisma Enum at`apps/ebtsServer/prisma/schema.prisma`
var TransactionStatusEnum;
(function (TransactionStatusEnum) {
    TransactionStatusEnum["NEW"] = "NEW";
    TransactionStatusEnum["SENT"] = "SENT";
    TransactionStatusEnum["SENT_ERROR"] = "SENT_ERROR";
    TransactionStatusEnum["RECEIVED"] = "RECEIVED";
    TransactionStatusEnum["RECEIVED_ERROR"] = "RECEIVED_ERROR";
    TransactionStatusEnum["PROCESSED"] = "PROCESSED";
    TransactionStatusEnum["PROCESSED_ERROR"] = "PROCESSED_ERROR";
    TransactionStatusEnum["EXCEPTION"] = "EXCEPTION";
})(TransactionStatusEnum = exports.TransactionStatusEnum || (exports.TransactionStatusEnum = {}));
var TransactionAction;
(function (TransactionAction) {
    TransactionAction["SUBMIT"] = "SUBMIT";
    TransactionAction["RESUBMIT"] = "RESUBMIT";
    TransactionAction["RESUBMIT_ON_ERROR"] = "RESUBMIT_ON_ERROR"; // with edits? check that known error fields have been updated
})(TransactionAction = exports.TransactionAction || (exports.TransactionAction = {}));
const completeOnSendTransactionActionMap = {
    [TransactionStatusEnum.NEW]: [TransactionAction.SUBMIT],
    [TransactionStatusEnum.SENT]: []
};
const completeOnReceiveTransactionActionMap = Object.assign(Object.assign({}, completeOnSendTransactionActionMap), { [TransactionStatusEnum.RECEIVED]: [] });
// example no resbubmit action setup
// const noResubmitTransactionActionMap = {
//   ...completeOnReceiveTransactionActionMap,
//   [TransactionStatusEnum.PROCESSED]: [] as TransactionAction[],
//   [TransactionStatusEnum.PROCESSED_ERROR]: [] as TransactionAction[]
// }
const resubmitTransactionActionMap = Object.assign(Object.assign({}, completeOnReceiveTransactionActionMap), { [TransactionStatusEnum.PROCESSED]: [TransactionAction.RESUBMIT], [TransactionStatusEnum.PROCESSED_ERROR]: [TransactionAction.RESUBMIT_ON_ERROR] });
exports.transactionActionMap = resubmitTransactionActionMap;
//# sourceMappingURL=types.js.map